var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.1907 47.9727L26.6001 41.8789V86.907C26.6005 87.3962 26.6973 87.8805 26.8848 88.3323C27.0724 88.7841 27.3471 89.1945 27.6933 89.5401C28.0395 89.8857 28.4504 90.1597 28.9025 90.3466C29.3546 90.5334 29.839 90.6293 30.3282 90.6289H90.0157C90.5054 90.6301 90.9905 90.5348 91.4434 90.3484C91.8962 90.1619 92.3078 89.888 92.6546 89.5423C93.0015 89.1966 93.2768 88.7859 93.4648 88.3337C93.6527 87.8815 93.7497 87.3967 93.7501 86.907V70.3164L61.1907 47.9727Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1907 9.37891H30.3282C29.839 9.3785 29.3546 9.47444 28.9025 9.66126C28.4504 9.84808 28.0395 10.1221 27.6933 10.4677C27.3471 10.8133 27.0724 11.2237 26.8848 11.6755C26.6973 12.1273 26.6005 12.6116 26.6001 13.1008V29.6914L61.1907 50.0039L79.5063 56.0977L93.7501 50.0039V29.6914L61.1907 9.37891Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6001 29.6914H61.1907V50.0039H26.6001V29.6914Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.3563 25.625H26.6001V76.4062H51.3563C52.3428 76.4013 53.2876 76.0079 53.986 75.3113C54.6844 74.6146 55.0802 73.6708 55.0876 72.6844V29.3469C55.0802 28.3604 54.6844 27.4166 53.986 26.72C53.2876 26.0233 52.3428 25.6299 51.3563 25.625Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.322 27.6523H26.6001V78.4336H49.322C50.3084 78.4287 51.2532 78.0353 51.9516 77.3386C52.6501 76.642 53.0458 75.6982 53.0532 74.7117V31.3742C53.0458 30.3878 52.6501 29.444 51.9516 28.7473C51.2532 28.0507 50.3084 27.6572 49.322 27.6523Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.322 27.6523H26.6001V74.3711H49.322C50.3084 74.3662 51.2532 73.9728 51.9516 73.2761C52.6501 72.5795 53.0458 71.6357 53.0532 70.6492V31.3742C53.0458 30.3878 52.6501 29.444 51.9516 28.7473C51.2532 28.0507 50.3084 27.6572 49.322 27.6523Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.2876 27.6523H26.6001V74.3711H47.2876C48.2741 74.3662 49.2188 73.9728 49.9173 73.2761C50.6157 72.5795 51.0115 71.6357 51.0188 70.6492V31.3742C51.0115 30.3878 50.6157 29.444 49.9173 28.7473C49.2188 28.0507 48.2741 27.6572 47.2876 27.6523Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98125 27.6523H47.2875C48.2757 27.6515 49.2238 28.0431 49.9235 28.741C50.6231 29.4389 51.0171 30.386 51.0187 31.3742V68.618C51.0171 69.6062 50.6231 70.5533 49.9235 71.2512C49.2238 71.9491 48.2757 72.3407 47.2875 72.3398H9.98125C9.49181 72.3407 9.00701 72.245 8.55456 72.0584C8.1021 71.8718 7.69086 71.5978 7.34434 71.2521C6.99782 70.9065 6.72282 70.4959 6.53504 70.0439C6.34727 69.592 6.25041 69.1074 6.25 68.618V31.3742C6.25041 30.8848 6.34727 30.4002 6.53504 29.9482C6.72282 29.4963 6.99782 29.0857 7.34434 28.7401C7.69086 28.3944 8.1021 28.1204 8.55456 27.9338C9.00701 27.7472 9.49181 27.6515 9.98125 27.6523Z",
    fill: "url(#paint0_linear_15730_137904)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 62.1047L25.6594 49.9672L18.4719 37.8984H24.2437L28.1656 45.6266C28.5281 46.3578 28.7906 46.9016 28.9094 47.2641H28.9625C29.2187 46.6766 29.4906 46.1109 29.775 45.5578L33.9687 37.9109H39.2812L31.9094 49.9109L39.4688 62.1141H33.8156L29.2844 53.6422C29.074 53.278 28.8952 52.8963 28.75 52.5016H28.675C28.5429 52.8862 28.3667 53.2543 28.15 53.5984L23.4844 62.1047H17.8125Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.019 9.37891H61.1909V29.6914H93.7503V13.1008C93.7499 12.6113 93.653 12.1268 93.4653 11.6748C93.2775 11.2228 93.0025 10.8123 92.656 10.4666C92.3094 10.121 91.8982 9.847 91.4457 9.66037C90.9933 9.47373 90.5085 9.37809 90.019 9.37891Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1909 49.9961H93.7503V70.3086H61.1909V49.9961Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15730_137904",
    x1: 14.0437,
    y1: 24.7273,
    x2: 43.225,
    y2: 75.2648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.ab9995d0631fa19f852d9a0c86bfdda6.svg";
export { ForwardRef as ReactComponent };